import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconShield2"><Path fillRule="evenodd" clipRule="evenodd" d="M11.7071 1.55956C11.8943 1.48015 12.1057 1.48015 12.2929 1.55956L20.5429 5.05956C20.82 5.17713 21 5.44898 21 5.75V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V5.75C3 5.44898 3.17997 5.17713 3.45709 5.05956L11.7071 1.55956Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShield2;
